// assets
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

// icons
const icons = {
    MapOutlinedIcon,
};

// ==============================|| MENU ITEMS - LOCATIONS ||============================== //

const locations = {
    id: 'locations',
    title: 'Locations',
    type: 'group',
    subscriptionRequired: ['basic','standard','premium','enterprise','admin'],
    children: [
        {
            id: 'maps-recent-zips',
            title: 'Recent Users Map',
            type: 'item',
            url: '/maps/recent',
            icon: icons.MapOutlinedIcon,
            showInShopifyApp: true,
        },
    ]
};

export default locations;
